import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import '../../../../../../scss/weekpicker.css';
import '../../../../../../scss/modernDatePicker.css';
import CustomCalendarPicker from '../../../../CustomWeekPicker/CustomCalendarPicker';
import classes from './WeekFilter.module.scss';
import { calendarTypes, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import MainButton from '../../../../buttons/MainButton';
import { useWindowSize } from '../../../../../../utils/hooks';

export default function WeekFilter({ week = '', changeWeek }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.week')}
      text={t('dashboard.timesheets.filters.week')}
      active={!!week}
      open={open}
      setOpen={setOpen}
    >
      <div className={classes.container}>
        {week && size.width < responsiveSizeTimesheet && (
          <div
            role="presentation"
            className={classes.resetTxtBtn}
            onClick={() => {
              changeWeek('');
              setOpen(false);
            }}
          >
            {t('dashboard.timesheets.filters.reset').split(' ')[0]}
          </div>
        )}
        <CustomCalendarPicker
          userDate={!week ? '' : dayjs(week)}
          setUserDate={(day) => {
            changeWeek(
              dayjs(day.toString())
                .add(1 - day.getDay(), 'day')
                .format('DD-MMM-YYYY')
            );
            if (size.width > responsiveSizeTimesheet) setOpen(false);
          }}
          calendarType={calendarTypes.WEEK}
        />
        {week && size.width > responsiveSizeTimesheet && (
          <MainButton
            outlined
            rounded
            size={size.width < responsiveSizeTimesheet ? 'small' : 'xsmall'}
            forceWidth={size.width < responsiveSizeTimesheet ? '100%' : '136px'}
            action={() => {
              changeWeek('');
              setOpen(false);
            }}
          >
            <p>{t('dashboard.timesheets.filters.reset')}</p>
          </MainButton>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
